import gbAntTableTrForm from "./src/gb-ant-table-tr-form.vue";
const gbAntTableTrFormCompenet = function(Vue) {
  Vue.component(gbAntTableTrForm.name, gbAntTableTrForm);
};
export default gbAntTableTrFormCompenet;
